export default __webpack_public_path__ + "69c088fc84fb44ed6019f59e8b42491a.png";